module.exports = __webpack_public_path__ + "static/media/store-AppleMusic.17cb41c8.svg";